import { defineStore } from 'pinia';


// ===== Cookie 读取辅助函数 =====
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        try {
            return decodeURIComponent(parts.pop().split(';').shift());
        } catch (e) {
            return parts.pop().split(';').shift();
        }
    }
    return null;
}
// ================================

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    isLoggedIn: false,
  }),
  
  getters: {
    getUserLoggedIn: (state) => !!state.user,
    userId: (state) => state.user?.customer_id || null,
    getCustomId: (state) => state.user?.customer_id || null,
    getBalancePoints: (state) => state.user?.balancepoints || 0,
    getUsername: (state) => state.user?.username,
  },
  
  actions: {
    setUser(user) {
      this.user = user;
      this.isLoggedIn = true;
    },
    
    updateBalance(newBalance) {
      if (this.user) {
        this.user.balance = newBalance;
      }
    },
    
    logout() {
      this.user = null;
      this.isLoggedIn = false;
    },
    
    initializeFromStorage() {
      console.log('🔍 ordersong 開始初始化認證狀態...');
      
      // 清除舊的 ordersong localStorage 數據，統一使用主系統認證
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      console.log('ℹ️ 已清除舊的 ordersong localStorage 數據，統一使用主系統認證');
      
      // ===== 優先從 Cookie 讀取認證數據（跨子域共享）=====
      console.log('🔍 檢查 Cookie 中的跨域認證數據...');
      const cookieToken = getCookie('auth_token');
      const cookieUserInfo = getCookie('user_info');
      
      if (cookieToken && cookieUserInfo) {
        console.log('✅ 從 Cookie 讀取到跨域認證數據');
        console.log('原始 Cookie user_info:', cookieUserInfo.substring(0, 100));
        
        // 完整清理流程
        let cleanedUserInfo = cookieUserInfo
          // 1. 去掉外层引号（如果有）
          .replace(/^"(.*)"$/, '$1')
          // 2. 替换八进制转义
          .replace(/\054/g, ',')
          .replace(/\042/g, '\"')
          // 3. 处理其他转义
          .replace(/\n/g, '\n')
          .replace(/\t/g, '\t');
        
        console.log('清理后的 user_info:', cleanedUserInfo.substring(0, 100));
        
        // 验证能否解析
        try {
          const testParse = JSON.parse(cleanedUserInfo);
          console.log('✅ JSON 验证通过:', testParse);
        } catch (e) {
          console.error('❌ JSON 验证失败:', e);
          console.log('将使用原始 Cookie 值');
          cleanedUserInfo = cookieUserInfo;
        }
        
        // 同步到 localStorage
        localStorage.setItem('auth_token', cookieToken);
        localStorage.setItem('user_info', cleanedUserInfo);
        console.log('✅ 已將 Cookie 認證同步到 localStorage');
      } else {
        console.log('⚠️  Cookie 中沒有認證數據');
      }
      // ===== Cookie 檢查結束 =====
      
      // 統一從主系統的 localStorage 讀取認證狀態
      const mainSystemUser = localStorage.getItem('user_info');
      const mainSystemToken = localStorage.getItem('auth_token');
      
      console.log('🔍 ordersong 檢查主系統認證數據:', {
        hasMainSystemUser: !!mainSystemUser,
        hasMainSystemToken: !!mainSystemToken,
        userData: mainSystemUser ? (() => { try { return JSON.parse(mainSystemUser); } catch { return "解析失败"; } })() : null,
        token: mainSystemToken ? mainSystemToken.substring(0, 20) + '...' : null
      });
      
      // 如果主系統有認證數據，備份到多個位置以防會話丟失
      if (mainSystemUser && mainSystemToken) {
        try {
          // 1. 備份到 sessionStorage
          sessionStorage.setItem('auth_token_backup', mainSystemToken);
          sessionStorage.setItem('user_info_backup', mainSystemUser);
          console.log('ℹ️ 已備份主系統認證數據到 sessionStorage');
          
          // 2. 備份到 ordersong 的 localStorage
          localStorage.setItem('main_auth_token_backup', mainSystemToken);
          localStorage.setItem('main_user_info_backup', mainSystemUser);
          console.log('ℹ️ 已額外備份到 ordersong localStorage 作為雙重備份');
          
          // 3. 備份到 cookie（最強健的備份機制）
          const expiresDate = new Date();
          expiresDate.setDate(expiresDate.getDate() + 7); // 7天過期
          
          // 設置 Cookie 以支持跨域訪問
          document.cookie = `main_auth_token_backup=${encodeURIComponent(mainSystemToken)}; expires=${expiresDate.toUTCString()}; path=/; domain=.ngrok-free.app`;
          document.cookie = `main_user_info_backup=${encodeURIComponent(mainSystemUser)}; expires=${expiresDate.toUTCString()}; path=/; domain=.ngrok-free.app`;
          console.log('ℹ️ 已備份到 cookie 作為三重備份');
          
          // 4. 設置返回主系統的 URL（最可靠的備份機制）
          const returnUrl = `${window.location.origin}/?auth_token=${encodeURIComponent(mainSystemToken)}&user_info=${encodeURIComponent(mainSystemUser)}&from_ordersong=true`;
          localStorage.setItem('main_system_return_url', returnUrl);
          console.log('ℹ️ 已設置返回主系統的 URL 作為四重備份');
        } catch (e) {
          console.error('❌ 備份失敗:', e);
        }
      } else {
        console.log('ℹ️ 主系統沒有認證數據，跳過備份');
      }
      
      if (mainSystemUser && mainSystemToken) {
        try {
          let userData;
          try {
            // 尝试直接解析
            // 清理并解析
            const cleanedUser = mainSystemUser.replace(/\\054/g, ',').replace(/\\042/g, '"');
            userData = JSON.parse(cleanedUser);
          } catch (e) {
            console.warn('⚠️  JSON 解析失败，尝试清理转义字符...', e);
            try {
              // 尝试清理 octal 转义字符（如 ,）
              const cleaned = mainSystemUser.replace(/\0(\d{2})/g, function(match, code) {
                return String.fromCharCode(parseInt(code, 8));
              });
              // 进一步清理八进制转义
              const finalCleaned = cleaned.replace(/\\054/g, ',').replace(/\\042/g, '"');
              userData = JSON.parse(finalCleaned);
              console.log('✅ 清理后成功解析 JSON');
            } catch (e2) {
              console.error('❌ 清理后仍然无法解析 JSON:', e2);
              console.log('原始数据:', mainSystemUser);
              // 如果还是失败，清除损坏的数据
              localStorage.removeItem('user_info');
              localStorage.removeItem('auth_token');
              throw new Error('用户数据已损坏，请重新登录');
            }
          }
          
          // 轉換為 ordersong 格式的用戶數據
          const ordersongUserData = {
            id: userData.id,
            customer_id: userData.customer_id || `C${userData.id}`,
            username: userData.username,
            email: userData.email,
            balancepoints: userData.balance_points || 0,
            expired_date: userData.expired_date || null  // 歌點通服務到期日期
          };
          
          this.user = ordersongUserData;
          this.isLoggedIn = true;
          
          console.log('✅ 從主系統初始化 ordersong 用戶狀態:', ordersongUserData);
          return;
        } catch (e) {
          console.error('無法解析主系統的用戶信息:', e);
        }
      }
      
      console.log('ℹ️ ordersong 沒有找到有效的認證狀態');
    },
    
    setupCrossSystemSync() {
      console.log('ℹ️ 設置 Cookie 實時監聽...');
      
      // 标志位：防止重复处理
      let isProcessingLogout = false;
      
      // 每5秒检查一次 Cookie 是否还存在
      setInterval(() => {
        // 如果正在处理登出，跳过
        if (isProcessingLogout) return;
        
        const cookieToken = getCookie('auth_token');
        const cookieUser = getCookie('user_info');
        
        // 如果当前是登录状态，但 Cookie 已清除
        if (this.isLoggedIn && (!cookieToken || !cookieUser)) {
          console.log('⚠️  檢測到 Cookie 已清除，同步登出狀態');
          
          isProcessingLogout = true;
          
          // 清除所有本地存储（避免从备份恢复）
          localStorage.clear();
          sessionStorage.clear();
          
          // 清除所有 Cookie
          document.cookie.split(';').forEach(cookie => {
            const name = cookie.split('=')[0].trim();
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
          });
          
          this.logout();
          
          console.log('✅ 已同步登出，3秒后刷新页面');
          
          // 延迟刷新，让日志显示出来
          setTimeout(() => {
            window.location.href = '/';
          }, 3000);
        }
      }, 5000);
    }
  },
  
  persist: true,
});


